export default __webpack_public_path__ + "static/media/css.7b2551a5.less";